module.exports = __webpack_public_path__ + "img/stock_img1.3cfe962d.png";